<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Timbrar depósito efectivo
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Finanzas</span>
            <span> /</span>
            <span>Timbrar depósito efectivo</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
    <form [formGroup]='formHeader' novalidate>
        <div class="card-body justify-content-between">
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                        formHeader.get('fechaDesde').invalid &&
                        (formHeader.get('fechaDesde').dirty ||
                        formHeader.get('fechaDesde').touched)
                        ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha desde
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
                            formControlName="fechaHasta">
                        </mdb-date-picker>
                        <div *ngIf="
                        formHeader.get('fechaHasta').invalid &&
                        (formHeader.get('fechaHasta').dirty ||
                        formHeader.get('fechaHasta').touched)
                        ">
                            <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                                Ingrese fecha hasta
                            </mdb-error>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
        <div></div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
        </button>
    </div>
</div>

<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <div class="table-responsive" *ngIf="listaDepositos">

            <app-no-data-alert *ngIf="listaDepositos?.length === 0">
            </app-no-data-alert>

            <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaDepositos?.length > 0">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">
                            <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
                        </th>
                        <th scope="col">Fecha Depósito</th>
                        <th scope="col">RUT</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Banco</th>
                        <th scope="col">Nro. Cuenta</th>
                        <th scope="col">Nro. Depósito</th>
                        <th scope="col">Fecha Timbrado</th>
                        <th scope="col">Monto</th>
                        <th scope="col">Estado</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let deposito of listaDepositos">
                        <td>
                            <div class="row" style="max-width: 85px;">
                                <div class="col" style="max-width: 40px;">
                                    <mdb-checkbox [checked]="deposito.seleccion" (change)='checkDetalle(deposito)' *ngIf="!deposito.estado">
                                    </mdb-checkbox>
                                </div>
                            </div>
                        </td>
                        <td>{{deposito.fecha_deposito | fecha}}</td>
                        <td>{{deposito.depositanteRutFormato | rut}}</td>
                        <td>{{deposito.depositante_nombre}}</td>
                        <td>{{deposito.banco_nombre}}</td>
                        <td>{{deposito.numero_cuenta}}</td>
                        <td>{{deposito.numero_deposito}}</td>
                        <td>{{deposito.fecha_timbrado | fecha}}</td>
                        <td align="right">$ {{deposito.monto | numerico}}</td>
                        <td align="center">
                            <mdb-badge pill="true" *ngIf="!deposito.estado" warning="true">Por depositar</mdb-badge>
                            <mdb-badge pill="true" *ngIf="deposito.estado" success="true">Depositado</mdb-badge>
                        </td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaDepositos?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaDepositos?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
        <button mdbBtn type="button" color="success" mdbWavesEffect (click)="timbrar()">
            Timbrar
        </button>
    </div>
</div>